import React from 'react';
import { observer } from 'mobx-react';
import { useStore } from '@ui/hooks/useStore';
import RegisterContainer from '../Register/Register.container';
import ConfirmContainer from '../Confirm/Confirm.container';
import ConfirmSuccessContainer from '../Confirm-success/Confirm-success.container';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';
import LoginContainer from './Login.container';
import PasswordRecoveryWrapContainer from '../Password-recovery/Password-recovery-wrap.component';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { user, modal } = useStore();

    if (modal.window === 'authentication') {
        return (
            <>
                <LoginContainer onClose={onClose} />
            </>
        );
    } else if (modal.window === 'passwordRecovery') {
        return (
            <>
                <PasswordRecoveryWrapContainer onClose={onClose} />
            </>
        );
    } else if (user.confirmed || user.confirmationErr) {
        return (
            <>
                <ConfirmSuccessContainer onClose={onClose} />
            </>
        );
    } else {
        if (!user.email) {
            return (
                <>
                    <RegisterContainer onClose={onClose} />
                </>
            );
        } else {
            return (
                <>
                    <ConfirmContainer onClose={onClose} />
                </>
            );
        }
    }
};

const LoginWrapContainer = observer(Container);

export default LoginWrapContainer;
